<div class="create-levels-map">
    <button class="btn-close-dialog" (click)="cancel()" title="Cerrar">
        <i class="fa-light fa-xmark"></i>
    </button>
    <div class="main-create-levels-map">
        <h1 class="title-create-levels">Configurar niveles del mapa</h1>
        <p class="subtitle">Define los diferentes niveles para tu mapa de asientos: Patio de butacas, 1º
            Anfiteatro, etc</p>

        <div class="sections-list">
            <div *ngFor="let level of levels; let i = index">
                <div class="section-item">
                    <div class="section-color" [style.background-color]="level.color"></div>

                    <div class="form-new-level w-100">
                        <div class="form-grid">
                            <div class="mb-1 w-100">
                                <p class="label-input">Nombre de la sección</p>
                                <div class="form-input-container ">
                                    <input type="text" class="w-100" [value]="level.name"
                                        placeholder="Ej: Platea, 1º Anfiteatro..." maxlength="50" [required]="true"
                                        (input)="updateLevelName(level, $event)">
                                </div>
                            </div>
                            <div class="mb-1" style="max-width: 90px;">
                                <p class="label-input">Prioridad</p>
                                <div class="form-input-container">
                                    <input type="number" class="w-100" [value]="level.orderBuy" min="1"
                                        placeholder="1" (input)="updateLevelOrderBuy(level, $event)">
                                </div>
                            </div>
                            <div class="mb-1 form-input-color">
                                <p class="label-input">Color</p>
                                <div class="d-flex align-items-center" style="gap: 6px;">
                                    <div class="form-input-container color-hex-container">
                                        <input type="text" class="w-100" [value]="level.color"
                                            placeholder="#Hex" maxlength="7"
                                            (input)="updateLevelColor(level, $event)">
                                        <div class="block-color">
                                            <input type="color" [value]="level.color"
                                                (input)="updateLevelColor(level, $event)">
                                        </div>
                                    </div>
                                    <button *ngIf="isColorModified(level)" class="btn-reset-color"
                                        (click)="resetLevelColor(level)" title="Restablecer color original">
                                        <i class="fa-light fa-rotate-left"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button class="btn-delete" (click)="deleteLevel(level)" [disabled]="levels.length <= 1"
                        title="Eliminar sección">
                        <i class="fa-light fa-trash-xmark"></i>
                    </button>
                </div>
                <mat-divider *ngIf="i !== levels.length - 1"></mat-divider>
            </div>
        </div>

        <div class="add-new-levels">
            <div class="btn-new btn-create m-0 d-flex" (click)="addLevel()">
                <i class="fa-light fa-plus"></i>
                <p class="m-0"> Agregar Nivel</p>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="footer-create-levels-map">
        <div class="btn-new btn-create btn-create-border m-0" (click)="cancel()">
            <p class="m-0">Cancelar</p>
        </div>
        <div class="btn-new btn-create m-0" (click)="confirmSections()">
            <!-- [class.disabled]="formNewManager.invalid"> -->
            <p class="m-0">Guardar</p>
        </div>
    </div>
</div>